var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6174_186583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3828 29.8828C21.8984 30.375 21.1016 30.375 20.6172 29.8828L15.6172 24.8828C15.125 24.3984 15.125 23.6016 15.6172 23.1172C16.1016 22.625 16.8984 22.625 17.3828 23.1172L21.5 27.2344L30.6172 18.1172C31.1016 17.625 31.8984 17.625 32.3828 18.1172C32.875 18.6016 32.875 19.3984 32.3828 19.8828L22.3828 29.8828ZM44 24C44 35.0469 35.0469 44 24 44C12.9531 44 4 35.0469 4 24C4 12.9531 12.9531 4 24 4C35.0469 4 44 12.9531 44 24ZM24 6.5C14.3359 6.5 6.5 14.3359 6.5 24C6.5 33.6641 14.3359 41.5 24 41.5C33.6641 41.5 41.5 33.6641 41.5 24C41.5 14.3359 33.6641 6.5 24 6.5Z",
    fill: "#7DBE50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6174_186583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.af527a331b6988b3cecf200e3a4098d1.svg";
export { ForwardRef as ReactComponent };